export default "__VITE_ASSET__Cd3X6jag__"